import { defineComponent, createElementBlock, openBlock, createBlock, createCommentVNode, createSlots, renderList, withCtx, renderSlot, normalizeProps, guardReactiveProps } from 'vue';
import _sfc_main$1 from './basler-components.es200.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es202.js';
/* empty css                        */

const _hoisted_1 = { class: "products-list" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductList",
  props: {
    displayMode: { default: "grid" },
    items: {},
    size: { default: "full" },
    defaultColumns: {},
    attributeColumns: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.displayMode === "grid" ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          items: _ctx.items,
          size: _ctx.size
        }, createSlots({ _: 2 }, [
          renderList(_ctx.$slots, (_, slot) => {
            return {
              name: slot,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(scope)))
              ])
            };
          })
        ]), 1032, ["items", "size"])) : _ctx.displayMode === "table-list" && _ctx.defaultColumns && _ctx.attributeColumns ? (openBlock(), createBlock(_sfc_main$2, {
          key: 1,
          "default-columns": _ctx.defaultColumns,
          "attribute-columns": _ctx.attributeColumns,
          items: _ctx.items
        }, createSlots({ _: 2 }, [
          renderList(_ctx.$slots, (_, slot) => {
            return {
              name: slot,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(scope)))
              ])
            };
          })
        ]), 1032, ["default-columns", "attribute-columns", "items"])) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
